import { createStyles, Grid, Theme, Typography, withStyles, WithStyles } from '@material-ui/core'
import React from 'react'
import { INDUSTRIES } from '../../formAssets'
import OutcomeDropDownItem from '../../FormTemplates/CustomOutcomeDropDown/OutcomeDropDownItem'
import OutcomeTextItem from '../../FormTemplates/CustomOutcomeTextItem/OutcomeTextItem'
import Autocomplete from 'src/components/Outcomes/Autocomplete'
import CustomAutocomplete from 'src/components/Outcomes/CustomAutocomplete'
import CustomSearchAutocomplete from 'src/components/Outcomes/CustomSearchAutocomplete'

interface IncumbentWorkersInfoSectionProps extends WithStyles<typeof styles> {
	handleIncumbentEmployerChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	handleIndustryChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	handlePromotionChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	handleWageIncreaseChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	incumbentEmployer: string
	jobPlacementIndustry: string
	positionBackfilledStringVal: string
	handlePositionBackfilledChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	promotionStringVal: string
	wageIncreaseStringVal: string
  employers: any[]
}

export const IncumbentWorkersInfoSection: React.FC<IncumbentWorkersInfoSectionProps> = (
	props: IncumbentWorkersInfoSectionProps,
) => {
	const {
		classes,
		handleIncumbentEmployerChange,
		handleIndustryChange,
		handlePositionBackfilledChange,
		handlePromotionChange,
		handleWageIncreaseChange,
		incumbentEmployer,
		jobPlacementIndustry,
		positionBackfilledStringVal,
		promotionStringVal,
		wageIncreaseStringVal,
	} = props

	return (
		<div className={classes.root}>
			<Typography variant="h5" className={classes.sectionSubtitle}>
				Incumbent Worker Information
			</Typography>

			<Grid container={true} spacing={8}>
				<Grid item={true} xs={12}>
					{/* <OutcomeTextItem
						required={true}
						label="Employer"
						placeholder="Employer Name"
						prop="incumbentEmployer"
						value={incumbentEmployer}
						onInputChange={handleIncumbentEmployerChange}
						maxLength={55}
						otherProps={{
							pattern: "^([a-zA-Z0-9]|[- @\\.#'&!])*$",
							autoFocus: false,
						}}
					/> */}

        {/* <Autocomplete suggestions={props.employers?.map(e=>e.employer_name)}
          label="Employer"
          required={true}
          placeholder="Employer Name"
          name="incumbentEmployer"
          value={incumbentEmployer}
          onInputChange={handleIncumbentEmployerChange} /> */}
        {/* <CustomAutocomplete
          label="Employer"
          required={true}
          placeholder="Employer Name"
          name="incumbentEmployer"
        /> */}

        <CustomSearchAutocomplete
          label="Employer"
          required={true}
          placeholder="Employer Name"
          name="incumbentEmployer"
        />

          

				</Grid>
				<Grid item={true} xs={12}>
					<OutcomeDropDownItem
						hideUnknown={true}
						label="Industry"
						prop="jobPlacementIndustry"
						value={jobPlacementIndustry}
						onInputChange={handleIndustryChange}
						required={true}
						items={INDUSTRIES}
						fullWidth={true}
					/>
				</Grid>
				<Grid item={true} xs={12}>
					<OutcomeDropDownItem
						hideUnknown={false}
						label="Received raise"
						prop="wageIncrease"
						value={wageIncreaseStringVal}
						onInputChange={handleWageIncreaseChange}
						items={['Yes', 'No']}
					/>
				</Grid>
				<Grid item={true} xs={12}>
					<OutcomeDropDownItem
						hideUnknown={false}
						label="Received promotion"
						prop="promotion"
						value={promotionStringVal}
						onInputChange={handlePromotionChange}
						items={['Yes', 'No']}
					/>
				</Grid>
				<Grid item={true} xs={12}>
					<OutcomeDropDownItem
						hideUnknown={false}
						label="Position back-filled"
						prop="positionBackfilled"
						value={positionBackfilledStringVal}
						onInputChange={handlePositionBackfilledChange}
						items={['Yes', 'No']}
					/>
				</Grid>
			</Grid>
		</div>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		root: {},
		sectionSubtitle: {
			padding: `${theme.spacing.unit}px 0`,
		},
	})

export default withStyles(styles)(IncumbentWorkersInfoSection)
